module.exports = __webpack_public_path__ + "img/close_icon.e70116ac.png";